import { getFromLocalStorage, setInLocalStorage } from './localStorage';

const RELEASED_KEY = 'tcc_released_features';
let _versions = {};

/**
 * LocalStorage getter wrapper
 * @returns {Object} RELEASED_KEY json parsed values from LocalStorage
 */
export function getVersions() {
  return _versions;
}

/**
 * @param {String} id Module Id
 * @return {String?} Versions.json Hash
 */
export function getHash(id) {
  const versions = getVersions();
  return versions ? versions[id] : null;
}

/**
 * @param {String} id Module Id
 * @param {String} hash New Hash
 * @returns {String} Version Hash
 */
export function setHash(id, hash) {
  const versions = getVersions();
  const newVersions = { ...versions, [id]: hash };
  _versions = newVersions;
  return getHash(id);
}

export function store() {
  try {
    // Clear before storing
    if (getFromLocalStorage(RELEASED_KEY)) {
      setInLocalStorage(RELEASED_KEY, null);
    }
    setInLocalStorage(RELEASED_KEY, _versions);
  } catch (e) {
    // Damage Control
    // eslint-disable-next-line no-console,no-inline-comments
    console.warn('Error storing the versions', e); // NOSONAR
  }
}
